<template>
  <div>
    <Fieldset :legend="$t('searchHeader')" :toggleable="true">
      <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2">
        <div class="p-formgrid p-grid p-col">
          <div class="p-field p-col-3">
            <label for="permissionOptions">{{ $t("level") }}</label>
            <Dropdown
              v-model="permissionSelect"
              :options="permissionOptions"
              optionLabel="permission_name"
              :filter="true"
              :placeholder="$t('placeholderSelectBox')"
              :showClear="true"
            >
              <template #value="permissionOptions">
                <div v-if="permissionOptions.value">
                  <div>{{ permissionOptions.value.permission_name }}</div>
                </div>
                <span v-else>
                  {{ permissionOptions.placeholder }}
                </span>
              </template>
              <template #option="permissionOptions">
                <div>{{ permissionOptions.option.permission_name }}</div>
              </template>
            </Dropdown>
          </div>
          <div class="p-field p-col-3">
            <label for="keyword">{{ $t("keyword") }}</label>
            <InputText id="usemenu_keyword" type="text" v-model="keyword" />
          </div>
          <div class="p-field p-col">
            <div class="p-formgrid p-grid p-jc-end p-mt-5">
              <Button
                @click="clearSearchField()"
                :label="$t('clearBtn')"
                class="p-button-clear p-ml-3 p-mr-3"
              />
              <Button
                @click="searchGroupMenu()"
                :label="$t('searchBtn')"
                class="p-button-info"
              />
            </div>
          </div>
        </div>
      </div>
    </Fieldset>

    <div class="card p-fluid p-mt-2">
      <DataTable
        :value="groupMenu_table"
        :paginator="true"
        :rows="10"
        dataKey="id"
        :rowHover="true"
        :filters="filters"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
      >
        <template #header>
          <div class="p-grid">
            <div class="table-header p-col-1">
              <Button
                @click="groupMenuModal = true"
                :label="$t('addBtn')"
                class="p-button-success"
              />
            </div>
            <div class="table-header p-col-3" style="margin-left: auto">
              <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span>
            </div>
          </div>
        </template>
        <template #empty>{{ $t("TableEmpty") }}</template>
        <Column
          field="menu_group_code"
          :header="$t('iam_menugroup_code')"
          :sortable="true"
        >
          <template #body="dataTable">
            <div hidden>{{ dataTable.data.menu_id }}</div>
            {{ dataTable.data.menu_group_code }}
          </template>
        </Column>
        <Column
          field="menu_name"
          :header="$t('iam_menugroup_name')"
          :sortable="true"
        >
          <template #body="dataTable">
            {{ dataTable.data.menu_name }}
          </template>
        </Column>
        <Column field="permission_name" :header="$t('level')" :sortable="true">
          <template #body="dataTable">
            {{ dataTable.data.permission_name }}
          </template>
        </Column>
        <Column :header="$t('controlTable')">
          <template #body="dataTable">
            <div class="p-formgrid p-grid" v-if="checkNotAdminPermission(dataTable.data.user_organize)">
              <div class="p-field p-col">
                <Button
                  @click="
                    groupMenuModal = true;
                    editData(dataTable.data.menu_id);
                    temp = dataTable.data.menu_id;
                  "
                  icon="pi pi-pencil"
                  :label="$t('editBtn')"
                  class="p-button-rounded p-button-warning"
                />
              </div>
              <div class="p-field p-col">
                <Button
                  @click="
                    displayConfirmation = true;
                    temp = dataTable.data.menu_id;
                  "
                  icon="pi pi-trash"
                  :label="$t('deleteBtn')"
                  class="p-button-rounded p-button-danger"
                />
              </div>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>

    <!-- Manage permission level modal -->
    <Dialog
      :modal="true"
      :visible.sync="groupMenuModal"
      :style="{ width: '1000px' }"
      :contentStyle="{ 'overflow-y': 'scroll' }"
      :header="header"
    >
      <div class="confirmation-content">
        <label>{{ $t("iam_modal_subtitle") }}</label>
        <div class="p-fluid p-mt-3">
          <div class="p-grid">
            <div class="p-col-5">
              <Tree
                :value="treeValue"
                selectionMode="checkbox"
                :selectionKeys.sync="selectedTreeValue"
              ></Tree>
            </div>
            <div class="p-col-7" style="margin-top: -20px">
              <div class="p-formgrid p-grid p-col-12">
                <div class="p-field p-col">
                  <label for="iam_menugroup_code"
                    >{{ $t("iam_menugroup_code") }}
                    <span class="required-input">*</span></label
                  >
                  <InputText
                    id="iam_menugroup_code"
                    type="text"
                    v-model="iam_menugroup_code"
                    :class="{
                      'p-invalid':
                        error_iam_menugroup_code && !iam_menugroup_code,
                    }"
                  />
                  <small
                    class="p-invalid"
                    v-if="error_iam_menugroup_code && !iam_menugroup_code"
                    >{{ $t("iam_menugroup_code_validate") }}</small
                  >
                </div>
                <div class="p-field p-col">
                  <label for="iam_menugroup_name"
                    >{{ $t("iam_menugroup_name") }}
                    <span class="required-input">*</span></label
                  >
                  <InputText
                    id="iam_menugroup_name"
                    type="text"
                    v-model="iam_menugroup_name"
                    required="true"
                    autofocus
                    :class="{
                      'p-invalid':
                        error_iam_menugroup_name && !iam_menugroup_name,
                    }"
                  />
                  <small
                    class="p-invalid"
                    v-if="error_iam_menugroup_name && !iam_menugroup_name"
                    >{{ $t("iam_menugroup_name_validate") }}</small
                  >
                </div>
              </div>

              <div class="p-formgrid p-grid p-col-7">
                <div class="p-field p-col">
                  <label for="permissionOptions"
                    >{{ $t("level") }}
                    <span class="required-input">*</span></label
                  >
                  <Dropdown
                    v-model="iam_permissionSelect"
                    :options="permissionOptions"
                    optionLabel="permission_name"
                    :class="{
                      'p-invalid':
                        error_iam_menugroup_permission && !iam_permissionSelect,
                    }"
                    :filter="true"
                    :placeholder="$t('placeholderSelectBox')"
                    :showClear="true"
                  >
                    <template #value="permissionOptions">
                      <div v-if="permissionOptions.value">
                        <div>{{ permissionOptions.value.permission_name }}</div>
                      </div>
                      <span v-else>
                        {{ permissionOptions.placeholder }}
                      </span>
                    </template>
                    <template #option="permissionOptions">
                      <div>{{ permissionOptions.option.permission_name }}</div>
                    </template>
                  </Dropdown>
                  <small
                    class="p-invalid"
                    v-if="
                      error_iam_menugroup_permission && !iam_permissionSelect
                    "
                    >{{ $t("isu_permission_validate") }}</small
                  >
                </div>
              </div>

              <!-- {{selectedTreeValue}} -->
              <hr />
              <h5>{{ $t("iam_topic_setting_menu") }}</h5>
              <div class="p-formgrid p-grid p-col-12" style="margin-top: -10px">
                <div class="p-field p-col">
                  <label for="iam_setting_code">{{
                    $t("iam_setting_code")
                  }}</label>
                  <InputText
                    id="iam_setting_code"
                    type="text"
                    v-model="iam_setting_code"
                    disabled
                  />
                </div>
                <div class="p-field p-col">
                  <label for="iam_setting_type">{{
                    $t("iam_setting_type")
                  }}</label>
                  <InputText
                    id="iam_setting_type"
                    type="text"
                    v-model="iam_setting_type"
                    disabled
                  />
                </div>
              </div>
              <div class="p-formgrid p-grid p-col-12">
                <div class="p-field p-col">
                  <label for="iam_setting_file">{{
                    $t("iam_setting_file")
                  }}</label>
                  <InputText
                    id="iam_setting_file"
                    type="text"
                    v-model="iam_setting_file"
                    disabled
                  />
                </div>
                <div class="p-field p-col">
                  <label for="iam_setting_menuname">{{
                    $t("iam_setting_menuname")
                  }}</label>
                  <InputText
                    id="iam_setting_menuname"
                    type="text"
                    v-model="iam_setting_menuname"
                    disabled
                  />
                </div>
              </div>

              <div class="p-formgrid p-grid p-col-12">
                <div class="p-field p-col">
                  <label>{{ $t("iam_setting_usage") }}</label>
                  <div class="p-formgrid p-mt-2">
                    <RadioButton
                      :disabled="true"
                      name="iam_setting_usage"
                      value="1"
                      v-model="iam_setting_usage"
                    />
                    <label class="p-ml-2">{{
                      $t("iam_setting_usage_view")
                    }}</label>
                    <RadioButton
                      :disabled="true"
                      name="iam_setting_usage"
                      value="2"
                      v-model="iam_setting_usage"
                      class="p-ml-5"
                    />
                    <label class="p-ml-2">{{
                      $t("iam_setting_usage_manage")
                    }}</label>
                  </div>
                </div>
                <div class="p-field p-col p-mt-5">
                  <div class="p-field-checkbox p-mt-2">
                    <Checkbox
                      :disabled="true"
                      id="iam_setting_usage_manage_add"
                      name="iam_setting_usage_manage_add"
                      value="1"
                      v-model="iam_setting_usage_manage_add"
                    />
                    <label class="p-mr-5" for="iam_setting_usage_manage_add">{{
                      $t("iam_setting_usage_manage_add")
                    }}</label>

                    <Checkbox
                      :disabled="true"
                      id="iam_setting_usage_manage_edit"
                      name="iam_setting_usage_manage_edit"
                      value="1"
                      v-model="iam_setting_usage_manage_edit"
                    />
                    <label class="p-mr-5" for="iam_setting_usage_manage_edit">{{
                      $t("iam_setting_usage_manage_edit")
                    }}</label>

                    <Checkbox
                      :disabled="true"
                      id="iam_setting_usage_manage_delete"
                      name="iam_setting_usage_manage_delete"
                      value="1"
                      v-model="iam_setting_usage_manage_delete"
                    />
                    <label for="iam_setting_usage_manage_delete">{{
                      $t("iam_setting_usage_manage_delete")
                    }}</label>
                  </div>
                </div>
              </div>

              <div class="p-formgrid p-grid p-col-12">
                <div class="p-field p-col-10">
                  <label for="iam_organizeSelected">{{
                    $t("iam_setting_usage_manage")
                  }}</label>
                  <Dropdown
                    v-model="iam_organizeSelected"
                    :options="organizeOptions"
                    optionLabel="name"
                    :filter="true"
                    :placeholder="$t('placeholderSelectBox')"
                    :showClear="true"
                    disabled
                  >
                    <template #value="organizeOptions">
                      <div v-if="organizeOptions.value">
                        <div>{{ organizeOptions.value.name }}</div>
                      </div>
                      <span v-else>
                        {{ organizeOptions.placeholder }}
                      </span>
                    </template>
                    <template #option="organizeOptions">
                      <div>{{ organizeOptions.option.name }}</div>
                    </template>
                  </Dropdown>
                </div>
                <div class="p-field p-col p-mt-5">
                  <div class="p-formgrid p-grid">
                    <div class="p-field p-col">
                      <Button
                        icon="pi pi-times"
                        class="p-button-danger"
                        disabled
                      />
                    </div>
                    <div class="p-field p-col" style="margin-left: -10px">
                      <Button
                        icon="pi pi-check"
                        class="p-button-success"
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          v-if="selectedData != ''"
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="clearData()"
        />
        <Button
          v-else
          :label="$t('clearBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="clearData()"
        />
        <Button
          :label="$t('saveBtn')"
          icon="pi pi-check"
          class="p-button-text"
          @click="saveData()"
        />
      </template>
    </Dialog>

    <Dialog
      :modal="true"
      :header="$t('ConfirmDelete')"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <i
          class="pi pi-exclamation-triangle p-mr-3 p-mt2"
          style="font-size: 2rem"
        />
        <span>{{ $t("ConfirmDeleteSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmation = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="confirmDelete(temp)"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>

    <!-- Are you sure for close this modal -->
    <Dialog
      :modal="true"
      :header="$t('ConfirmCloseModal')"
      :visible.sync="displayConfirmationCloseModal"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <span>{{ $t("ConfirmCloseModalSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmationCloseModal = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="closeAllModal()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  name: "admin-menu",
  data() {
    return {
      keyword: "",
      permissionOptions: [],
      permissionSelect: null,

      groupMenu_table: [],
      filters: {},
      temp: null,
      selectedData: "",
      displayConfirmation: false,

      groupMenuModal: false,
      header: this.$i18n.t("iam_modal_title_add"),
      treeValue: [
        {
          key: "0",
          label: "หน้าหลักสำนัก",
          data: "หน้าหลักสำนัก",
          icon: "pi pi-fw pi-home",
        },
        {
          key: "1",
          label: "แผนที่สาธารณภัย",
          data: "แผนที่สาธารณภัย",
          icon: "pi pi-fw pi-map-marker",
        },
        {
          key: "2",
          label: "สถิติสาธารณภัย",
          data: "สถิติสาธารณภัย",
          icon: "pi pi-fw pi-chart-bar",
        },
        {
          key: "3",
          label: "ข้อมูลสารสนเทศ",
          data: "ข้อมูลสารสนเทศ",
          icon: "pi pi-fw pi-list",
          children: [
            {
              key: "3-0",
              label: "ข้อมูลระบบ",
              data: "ข้อมูลระบบ",
              children: [
                {
                  key: "3-0-0",
                  label: "ข้อมูลพื้นฐานระบบ",
                  data: "ข้อมูลพื้นฐานระบบ",
                },
                {
                  key: "3-0-1",
                  label: "ข้อมูลจังหวัด, อำเภอ, ตำบล",
                  data: "ข้อมูลจังหวัด, อำเภอ, ตำบล",
                },
              ],
            },
            {
              key: "3-1",
              label: "ข้อมูลตั้งต้น",
              data: "ข้อมูลตั้งต้น",
              children: [
                {
                  key: "3-1-0",
                  label: "ข้อมูลพื้นที่อพยพ",
                  data: "ข้อมูลพื้นที่อพยพ",
                },
                {
                  key: "3-1-1",
                  label: "ข้อมูลระดับความเสี่ยง",
                  data: "ข้อมูลระดับความเสี่ยง",
                },
                {
                  key: "3-1-2",
                  label: "ข้อมูลพื้นที่เสี่ยงภัย",
                  data: "ข้อมูลพื้นที่เสี่ยงภัย",
                },
                {
                  key: "3-1-3",
                  label: "ข้อมูลหน่วยงาน",
                  data: "ข้อมูลหน่วยงาน",
                },
                {
                  key: "3-1-4",
                  label: "ข้อมูลระบบป้องกัน/บรรเทาสาธารณภัย",
                  data: "ข้อมูลระบบป้องกัน/บรรเทาสาธารณภัย",
                },
                {
                  key: "3-1-5",
                  label: "ข้อมูลหลักสูตรการฝึกอบรม",
                  data: "ข้อมูลหลักสูตรการฝึกอบรม",
                },
                { key: "3-1-6", label: "ข้อมูลกำลังคน", data: "ข้อมูลกำลังคน" },
                { key: "3-1-7", label: "ข้อมูลอุปกรณ์สำนักงาน", data: "ข้อมูลอุปกรณ์สำนักงาน" },
                {
                  key: "3-1-8",
                  label: "ข้อมูลชุดเผชิญเหตุ",
                  data: "ข้อมูลชุดเผชิญเหตุ",
                },
                {
                  key: "3-1-9",
                  label: "ข้อมูลเครื่องมือ อุปกรณ์/ยานพาหนะ",
                  data: "ข้อมูลเครื่องมือ อุปกรณ์/ยานพาหนะ",
                },
                {
                  key: "3-1-10",
                  label: "ข้อมูลอาคาร/สิ่งปลูกสร้าง",
                  data: "ข้อมูลอาคาร/สิ่งปลูกสร้าง",
                },
                { key: "3-1-11", label: "UN Number", data: "UN Number" },
              ],
            },
            {
              key: "3-2",
              label: "ข้อมูลสาธารณภัย",
              data: "ข้อมูลสาธารณภัย",
            },
            {
              key: "3-3",
              label: "ข้อมูลผู้ประสบภัย",
              data: "ข้อมูลผู้ประสบภัย",
            },
            {
              key: "3-4",
              label: "สถิติจำนวนบุคลากร",
              data: "สถิติจำนวนบุคลากร",
            },
            {
              key: "3-5",
              label: "ผู้ดูแลระบบ",
              data: "ผู้ดูแลระบบ",
              children: [
                {
                  key: "3-5-0",
                  label: "ข้อมูลระดับสิทธิ์",
                  data: "ข้อมูลระดับสิทธิ์",
                },
                {
                  key: "3-5-1",
                  label: "ข้อมูลผู้ใช้งานระบบ",
                  data: "ข้อมูลผู้ใช้งานระบบ",
                },
                {
                  key: "3-5-2",
                  label: "ข้อมูลเมนูการใช้งาน",
                  data: "ข้อมูลเมนูการใช้งาน",
                },
                { key: "3-5-3", label: "Configuration", data: "Configuration" },
              ],
            },
          ],
        },
        {
          key: "4",
          label: "รายงาน",
          data: "รายงาน",
          icon: "pi pi-fw pi-file",
        },
        {
          key: "5",
          value: "suggestion",
          label: "ข้อเสนอแนะ",
          data: "ข้อเสนอแนะ",
          icon: "pi pi-fw pi-comments",
        },
        {
          key: "6",
          value: "manual",
          label: "คู่มือการใช้งาน",
          data: "คู่มือการใช้งาน",
          icon: "pi pi-fw pi-book",
        },
      ],
      selectedTreeValue: null,
      iam_menugroup_code: "",
      iam_menugroup_name: "",
      iam_permissionSelect: null,
      iam_setting_code: "",
      iam_setting_type: "",
      iam_setting_file: "",
      iam_setting_menuname: "",
      iam_setting_usage: "1",
      iam_setting_usage_manage_edit: "",
      iam_setting_usage_manage_add: "",
      iam_setting_usage_manage_delete: "",
      organizeOptions: [{ id: "1", name: "หน่วยงานเท่านั้น" }],
      iam_organizeSelected: { name: "หน่วยงานเท่านั้น" },
      error_iam_menugroup_name: false,
      error_iam_menugroup_code: false,
      error_iam_menugroup_permission: false,

      check_duplicate: "",
      displayConfirmationCloseModal: false,
      tempFor_displayConfirmationCloseModal: "",
    };
  },
  watch: {
    async groupMenuModal(val) {
      if (val == false) {
        if (
          this.tempFor_displayConfirmationCloseModal == "" &&
          this.selectedData == "" &&
          this.iam_menugroup_code != "" &&
          this.iam_menugroup_name != "" &&
          this.iam_permissionSelect != null
        ) {
          this.displayConfirmationCloseModal = true;
        } else {
          await this.axios
            .post(`${this.$url_service}/admin/permission`, {
              body: { topic: "get-option" },
            })
            .then((response) => {
              (this.permissionOptions = response.data.data),
                this.permissionOptions.splice(0, 0, {
                  permission_id: "getall",
                  permission_name: this.$i18n.t("selectAll"),
                });
            });
          this.clearData();
        }
      } else {
        await this.axios
          .post(`${this.$url_service}/admin/permission`, {
            body: { topic: "get-option" },
          })
          .then((response) => (this.permissionOptions = response.data.data));
      }
    },

    displayConfirmationCloseModal(val) {
      if (val == true) {
        this.groupMenuModal = true;
      }
    },

    check_duplicate(val) {
      if (val == "duplicate") {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "เพิ่มข้อมูลเมนูการใช้งานไม่สำเร็จ",
        //   detail: "มีข้อมูลเมนูการใช้งานนี้ในระบบแล้ว",
        //   life: 3000,
        // });
        this.$fire({
              type: "error",
              title: "เพิ่มข้อมูลเมนูการใช้งานไม่สำเร็จ",
              text: "มีข้อมูลเมนูการใช้งานนี้ในระบบแล้ว",
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
      } else {
        // this.$toast.add({
        //   severity: "success",
        //   summary: "เพิ่มข้อมูลสำเร็จ",
        //   detail: "ข้อมูลเมนูการใช้งาน",
        //   life: 3000,
        // });
        this.$fire({
              type: "success",
              title: "เพิ่มข้อมูลสำเร็จ",
              text: "ข้อมูลเมนูการใช้งาน",
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
      }
    },
  },
  created() {
    console.log('d')
    this.initialData();
  },

  methods: {
    async initialData() {
      await this.axios
        .post(`${this.$url_service}/admin/menu`, {
          body: {
            topic: "get-table",
            userOrg: this.checkPermission() ? null : this.getUserOrganize(),
          },
        })
        .then((response) => (this.groupMenu_table = response.data.data));
      await this.axios
        .post(`${this.$url_service}/admin/permission`, {
          body: { topic: "get-option" },
        })
        .then((response) => {
          (this.permissionOptions = response.data.data),
            this.permissionOptions.splice(0, 0, {
              permission_id: "getall",
              permission_name: this.$i18n.t("selectAll"),
            });
        });
    },

    closeAllModal() {
      this.groupMenuModal = false;
      this.displayConfirmationCloseModal = false;
      this.clearData();
    },

    async searchGroupMenu() {
      await this.axios
        .post(`${this.$url_service}/admin/menu`, {
          body: {
            topic: "search-table",
            keyword: this.keyword,
            level: this.permissionSelect,
          },
        })
        .then((response) => (this.groupMenu_table = response.data.data));
    },

    async confirmDelete() {
      this.displayConfirmation = false;
      await this.axios
        .post(`${this.$url_service}/admin/menu?user=${this.getUsername()}`, {
          body: {
            topic: "delete-menu",
            id: this.temp,
          },
        })
        .then(() => this.initialData());
      // this.$toast.add({
      //   severity: "success",
      //   summary: "ลบข้อมูลสำเร็จ",
      //   detail: "ข้อมูลเมนูการใช้งาน",
      //   life: 3000,
      // });
      this.$fire({
              type: "success",
              title: "ลบข้อมูลสำเร็จ",
              text: "ข้อมูลเมนูการใช้งาน",
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
    },

    async saveData() {
      //Check null value
      if (
        this.iam_menugroup_name == "" ||
        this.iam_menugroup_code == "" ||
        this.iam_permissionSelect == null
      ) {
        if (this.iam_menugroup_name == "") {
          this.error_iam_menugroup_name = true;
        }
        if (this.iam_menugroup_code == "") {
          this.error_iam_menugroup_code = true;
        }
        if (this.iam_permissionSelect == null) {
          this.error_iam_menugroup_permission = true;
        }
      } else {
        if (this.selectedData == "") {
          await this.axios
            .post(
              `${this.$url_service}/admin/menu?user=${this.getUsername()}`,
              {
                body: {
                  topic: "add-menu",
                  code: this.iam_menugroup_code,
                  name: this.iam_menugroup_name,
                  select: this.selectedTreeValue,
                  permission_id: this.iam_permissionSelect.permission_id,
                },
              }
            )
            .then((response) => {
              (this.check_duplicate = response.data.message),
                this.initialData();
            });
          console.log("Save data");
          this.tempFor_displayConfirmationCloseModal = "add";
          this.groupMenuModal = false;
        } else {
          await this.axios
            .post(
              `${this.$url_service}/admin/menu?user=${this.getUsername()}`,
              {
                body: {
                  topic: "edit-menu",
                  id: this.temp,
                  code: this.iam_menugroup_code,
                  name: this.iam_menugroup_name,
                  select: this.selectedTreeValue,
                  permission_id: this.iam_permissionSelect.permission_id,
                },
              }
            )
            .then(() => this.initialData());
          // this.$toast.add({
          //   severity: "success",
          //   summary: "แก้ไขข้อมูลสำเร็จ",
          //   detail: "ข้อมูลเมนูการใช้งาน",
          //   life: 3000,
          // });
          this.$fire({
              type: "success",
              title: "แก้ไขข้อมูลสำเร็จ",
              text: "ข้อมูลผู้ใช้งานระบบ",
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
          this.groupMenuModal = false;
        }
      }
    },

    async editData(data) {
      this.header = this.$i18n.t("iam_modal_title_edit");
      await this.axios
        .post(`${this.$url_service}/admin/menu`, {
          body: {
            topic: "showone-menu",
            id: data,
          },
        })
        .then((response) => {
          (this.selectedData = response.data.data),
            (this.iam_menugroup_name = response.data.data.menu_name),
            (this.iam_menugroup_code = response.data.data.menu_group_code),
            (this.selectedTreeValue = JSON.parse(
              response.data.data.menu_select
            )),
            (this.iam_permissionSelect = {
              permission_id: response.data.data.permission_id,
              permission_name: response.data.data.permission_name,
            });
        });
    },

    clearData() {
      //Edit data
      if (this.selectedData != "") {
        this.temp = null;
        this.header = this.$i18n.t("iam_modal_title_add");
        this.displayConfirmation = false;
        this.groupMenuModal = false;
        this.selectedData = "";
        this.setDefault();
        //Add data
      } else {
        this.temp = null;
        this.displayConfirmation = false;
        this.setDefault();
      }
    },

    setDefault() {
      this.tempFor_displayConfirmationCloseModal = "";
      this.iam_menugroup_name = "";
      this.iam_menugroup_code = "";
      this.iam_permissionSelect = null;
      (this.selectedTreeValue = null), (this.error_iam_menugroup_name = false);
      this.error_iam_menugroup_code = false;
      this.error_iam_menugroup_permission = false;
    },

    async clearSearchField() {
      this.permissionSelect = null;
      this.keyword = "";
      this.initialData()
    },
  },
};
</script>

<style scoped>
.p-field {
  margin-bottom: 0rem;
}
</style>

<style>
.p-datatable-thead {
  border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
  border: 2px solid #d6d6d6;
}
</style>
